import { useMemo } from 'react';
import { useLoaderData } from 'react-router';

import type { loader } from '~/routes/_app.project.$urlSegment._index';
import {
    DetailAwardsSection,
    toDetailAwards,
} from '~/ui-rocco/pages/detail-shared/DetailAwardsList';

/**
 * The project's awards on the page's dark ground: the profile's awards list
 * under its own head, after the gallery and before the people the project
 * credits.
 */
export const ProjectAwardsSection = () => {
    const { project } = useLoaderData<typeof loader>();
    const awards = useMemo(
        () => toDetailAwards(project.Awards),
        [project.Awards],
    );

    return <DetailAwardsSection awards={awards} theme="dark" />;
};
